<template>
  <div class="sectionBox">
    <!-- <van-search
      v-model="keywords"
      show-action
      placeholder="请输入搜索关键词"
      @search="searchBtnClick"
    >
      <template #action>
        <div @click="searchBtnClick">搜索</div>
      </template>
    </van-search> -->

    <div class="searchBoxOuts">
      <div class="searchBox">
        <van-field
          v-model="keywords"
          class="inputBox"
          label
          left-icon="search"
          placeholder="商品关键词"
        />
        <!-- <el-input v-model="keywords" placeholder="商品关键词" class="inputBox"></el-input> -->
        <el-button class="searchBtn" type="text" @click="searchBtnClick">
          搜 索
        </el-button>
      </div>
    </div>
    <div class="mainBox">
      <el-carousel height="4rem" arrow="never">
        <el-carousel-item v-for="item of bannerItem" :key="item.id">
          <el-image
            @click="href(item)"
            style="width: 100%; height: 100%"
            :src="item.imgUrl"
            fit="fill"
          ></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="box" style="display: flex; padding: 10px">
      <div style="width: 25%" @click="routers">
        <img style="width: 35px; height: 35px" src="../../assets/fl.png" />
        <div>商品分类</div>
      </div>
      <div @click="searchDialog" style="width: 25%">
        <img style="width: 35px; height: 35px" src="../../assets/dd.png" />
        <div>查询订单</div>
      </div>
      <div @click="serviceBtn" style="width: 25%">
        <img style="width: 35px; height: 35px" src="../../assets/kf.png" />
        <div>联系客服</div>
      </div>
      <div style="width: 25%" @click="routerse">
        <img style="width: 35px; height: 35px" src="../../assets/yw.png" />
        <div>疑问解答</div>
      </div>
    </div>

    <div class="box" style="padding-bottom: 10px; margin-bottom: 0">
      <van-tabs v-model="active" @change="onChange">
        <van-tab
          v-for="item of menuList"
          :key="item.id"
          :title="item.shopClassName"
        ></van-tab>
      </van-tabs>
    </div>

    <div class="xbox" style="margin-bottom: 52px; background: transparent">
      <div
        style="
          text-align: left;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
        "
      >
        <div
          v-for="item of storeList"
          :key="item.id"
          class="itemBox"
          @click="goToDetail(item.id)"
        >
          <div class="shopImg">
            <el-image
              style="width: 100%; height: 185px; border-radius: 5px"
              :src="item.shopUrl"
            ></el-image>
          </div>
          <div class="contBox">
            <div class="shopName" style="margin-top: 5px">
              {{ item.shopName ? item.shopName : "---" }}
            </div>
            <div class="shopTitle" style="margin-top: 5px">
              {{ item.shopTitle ? item.shopTitle : "---" }}
            </div>
            <div style="margin-top: 5px; height: 22px">
              <div class="shopPrice">
                ￥
                <span v-if="item.shopDivideModel" style="font-size: 20px">
                  {{ item.shopDivideModel.shopPrice }}
                </span>
                <span v-else style="font-size: 20px">
                  {{ item.shopPrice ? item.shopPrice : 0 }}
                </span>
              </div>
              <div class="shopNum">
                销量：{{
                  (item.fakeSales = 0 ? item.outNumber : item.fakeSales)
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="more">
        {{
          queryForm.page >= totalPage ? "暂无更多数据..." : "加载更多数据..."
        }}
      </div>
    </div>

    <!-- 查询订单 -->
    <van-overlay :show="show" @click="show = false" z-index="12">
      <div class="wrapper">
        <div class="block" @click.stop>
          <div class="tit1">查询订单</div>
          <div class="tit2">下单手机号查询订单</div>
          <div>
            <van-field
              v-model="userPhone"
              maxlength="11"
              class="inputDiv"
              type="tel"
              label
              placeholder="请输入下单手机号"
            />
          </div>
          <div>
            <van-field
              v-model="random"
              center
              class="inputDiv"
              clearable
              placeholder="请输入短信验证码"
            >
              <template #button>
                <van-button
                  size="small"
                  v-if="dd == false"
                  @click="change"
                  round
                  type="info"
                >
                  验证码
                </van-button>
                <van-button size="small" v-if="dd" disabled round>
                  <van-count-down
                    ref="count0"
                    :time="time"
                    :auto-start="false"
                    format="ss"
                    @finish="finishss"
                  />
                </van-button>
              </template>
            </van-field>
          </div>
          <el-button class="confirmBtn" @click="confirmBtn">确认查询</el-button>
        </div>
      </div>
    </van-overlay>
    <!-- 联系客服 -->
    <van-overlay
      :show="serviceDialog"
      @click="serviceDialog = false"
      z-index="12"
    >
      <div class="wrappers">
        <div class="blocks" @click.stop>
          <div class="tit1">联系客服</div>
          <div style="margin: 20px 0px 5px">
            <el-image
              style="width: 200px; height: 200px"
              :src="serviceInfo.imgUrl ? serviceInfo.imgUrl : ''"
            ></el-image>
          </div>
          <!-- <div class="tit2">
            {{ serviceInfo.content ? serviceInfo.content : "" }}
          </div> -->
          <div v-if="serviceInfo.weChatNumber">
            <van-field
              v-model="serviceInfo.weChatNumber"
              class="inputDiv"
              label
              placeholder="客服微信号"
              readonly
            >
              <template #button>
                <span
                  style="color: #409eff"
                  @click="
                    copyWeChatNumber(
                      serviceInfo.weChatNumber ? serviceInfo.weChatNumber : ''
                    )
                  "
                >
                  复制
                </span>
              </template>
            </van-field>
          </div>
        </div>
      </div>
    </van-overlay>
    <Tab v-if="tabbarIsShow"></Tab>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import {
    getStoreTypeList,
    getStoreList,
    shopCustomerModel,
    VerificationCode,
    VerificationCoding,
    carouselImageModelList,
  } from "@/api/shopping";
  import Tab from "@/components/Tab.vue";
  export default {
    components: {
      Tab,
    },
    data() {
      return {
        // banner轮播图
        bannerItem: [
          {
            id: 1,
            imgUrl: require("./../../assets/shopping/banner1.jpg"),
          },
          {
            id: 2,
            imgUrl: require("./../../assets/shopping/banner2.jpg"),
          },
        ],
        random: "",
        // 标签选中
        active: 0,
        nowTitle: "",
        nowTypeId: "",
        menuList: [],
        meCardNum: "",
        queryForm: {
          page: 1,
          size: 10,
        },
        keywords: "",
        storeList: [],
        totalPage: 1,
        show: false,
        userPhone: "",
        serviceDialog: false,
        serviceInfo: {},
        tabbarIsShow: false,
        dd: false,
        time: 60 * 1000,
        title: "",
      };
    },
    created() {
      if (this.$route.query.userId !== undefined) {
        localStorage.removeItem("meCardNum");
      }
    },

    mounted() {
      this.$nextTick(() => {
        // 监听滚动事件
        //类名为guest-info-box的div必须设置高度和 overflow-y: scroll;下面的代码才会生效
        let scrollTargetBox = document.querySelector(".xbox");
        scrollTargetBox.onscroll = () => {
          var scrollHeight = scrollTargetBox.scrollHeight; //251
          var scrollTop = scrollTargetBox.scrollTop; //0-18
          var clientHeight = scrollTargetBox.clientHeight; //233
          if (scrollHeight - clientHeight == scrollTop) {
            //滚动条滚到最底部
            if (this.queryForm.page >= this.totalPage) return;
            this.queryForm.page++;
            this.getStoreList();
          }
        };
      });
      this.getAll();
      if (this.$route.query.userId == undefined) {
        this.shopCustomerModels1();
        this.tabbarIsShow = true;
      } else {
        localStorage.setItem("userIds", this.$route.query.userId);
        this.tabbarIsShow = false;
        this.shopCustomerModels();
      }

      this.meCardNum = localStorage.getItem("meCardNum");
      this.getStoreTypeList();
      this.carouselImageModelList();
    },

    methods: {
      ...mapActions(["getAll"]),
      href(val) {
        if (val.url.indexOf("http") != -1) {
          window.location.href = val.url;
        }
      },
      change() {
        if (this.userPhone == "") {
          this.$notify({
            type: "warning",
            message: `手机号不能为空`,
          });
        } else {
          VerificationCode(this.userPhone).then((res) => {
            if (res.status) {
              console.log(res);
              this.$notify({
                type: "success",
                message: res.msg,
              });
              this.dd = true;
              this.start();
            } else {
              this.$notify({
                type: "warning",
                message: res.msg,
              });
            }
          });
        }
      },
      finishss() {
        this.dd = false;
      },
      start() {
        this.$nextTick(() => {
          this.$refs.count0.start();
        });
      },
      searchBtnClick() {
        this.storeList = [];
        this.totalPage = 1;
        this.queryForm.page = 1;
        this.getStoreList();
      },
      // 联系客服
      serviceBtn() {
        this.shopCustomerModel();
      },
      //商品名称
      shopCustomerModels() {
        var card = "";
        var userId = "";

        if (this.$route.query.userId !== undefined) {
          card = "";
          userId = this.$route.query.userId;
        } else {
          card = localStorage.getItem("meCardNum");
          userId = "";
        }
        shopCustomerModel(userId, card).then((res) => {
          if (res.status) {
            if (res.data) {
              document.title = res.data[0].shopName;
              this.title = res.data[0].shopName;
            }
          }
        });
      },
      //商品名称
      shopCustomerModels1() {
        var card = "";
        var userId = "";

        if (this.$route.query.userId !== undefined) {
          card = "";
          userId = this.$route.query.userId;
        } else {
          card = localStorage.getItem("meCardNum");
          userId = "";
        }
        shopCustomerModel(userId, card).then((res) => {
          if (res.status) {
            if (res.data.length > 0) {
              this.title = res.data[0].shopName;
            }
          }
        });
      },
      //轮播
      carouselImageModelList() {
        var card = "";
        var userId = "";

        if (this.$route.query.userId !== undefined) {
          card = "";
          userId = this.$route.query.userId;
        } else {
          card = localStorage.getItem("meCardNum");
          userId = "";
        }
        carouselImageModelList(userId, card).then((res) => {
          if (res.status) {
            if (res.data) {
              if (res.data.length > 0) {
                this.bannerItem = res.data;
              }
            } else {
              this.serviceInfo = {};
              this.$notify({ type: "warning", message: "管理员暂未设置客服" });
            }
          }
        });
      },

      shopCustomerModel() {
        var card = "";
        var userId = "";

        if (this.$route.query.userId !== undefined) {
          card = "";
          userId = this.$route.query.userId;
        } else {
          card = localStorage.getItem("meCardNum");
          userId = "";
        }
        shopCustomerModel(userId, card).then((res) => {
          if (res.status) {
            if (res.data.length > 0) {
              if (res.data[0].type == 0) {
                window.location.href = res.data[0].customerUrl;
              } else {
                this.serviceInfo = res.data[0];
                this.serviceDialog = true;
              }
            } else {
              this.serviceInfo = {};
              this.$notify({ type: "warning", message: "管理员暂未设置客服" });
            }
          }
        });
      },
      // 复制
      copyWeChatNumber(val) {
        // console.log(val);
        let input = document.createElement("input");
        input.value = val;
        input.id = "creatDom";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        // ===========================
        this.$notify({ type: "success", message: "复制成功!" });
      },
      // 确认查询
      confirmBtn() {
        if (this.userPhone) {
          var pattern = /^1\d{10}$/;
          var boolphone = pattern.test(this.userPhone);
          if (!boolphone) {
            this.$notify({ type: "warning", message: "请输入正确的手机号" });
            return false;
          } else {
            this.VerificationCoding();
          }
        } else {
          this.$notify({ type: "warning", message: "请输入下单手机号" });
        }
      },
      //验证短信
      VerificationCoding() {
        VerificationCoding(this.userPhone, this.random).then((res) => {
          if (res.code == 0) {
            localStorage.setItem("userPhone", this.userPhone);
            this.show = !this.show;
            this.$router.push(`/orderList`);
          }
        });
      },
      //分类
      routers() {
        this.$router.push(`/classify`);
      },
      //疑问
      routerse() {
        this.$router.push(`/problems`);
      },
      // 查询订单按钮
      searchDialog() {
        this.userPhone = "";
        this.show = true;
      },
      // 获取商品类型列表
      getStoreTypeList() {
        getStoreTypeList().then((res) => {
          if (res.status) {
            //  console.log(res.data)
            this.menuList = res.data;
            this.nowTitle = this.menuList[0].shopClassName;
            this.nowTypeId = this.menuList[0].id;
            this.getStoreList();
          }
        });
      },
      // 获取商品分页列表
      getStoreList() {
        let params = {};
        // console.log(this.$route.query.userId);
        if (this.$route.query.userId == undefined) {
          params = {
            shopClassId: this.nowTypeId,
            shopName: this.keywords,
            card: this.meCardNum,
          };
        } else {
          params = {
            shopClassId: this.nowTypeId,
            shopName: this.keywords,
            userId: this.$route.query.userId,
            sortName: "",
            sortType: "",
          };
        }

        getStoreList(this.queryForm, params).then((res) => {
          if (res.status) {
            //  console.log(res.data)
            if (res.data && res.data.list && res.data.list.length) {
              this.storeList = [...this.storeList, ...res.data.list];
              this.totalPage = res.data.totalPage;
            }
          }
        });
      },
      // 商品分类切换
      onChange() {
        this.storeList = [];
        this.totalPage = 1;
        this.nowTitle = this.menuList[this.active].shopClassName;
        this.nowTypeId = this.menuList[this.active].id;
        this.getStoreList();
      },
      // 商品详情
      goToDetail(ids) {
        localStorage.removeItem("userIds");
        localStorage.setItem("shopDetailId", ids);
        if (this.$route.query.userId !== undefined) {
          localStorage.setItem("userIds", this.$route.query.userId);
        }
        this.$router.push(`/shopDetail`);
      },
    },
  };
</script>
<style lang="scss">
  ::v-deep .van-tabs .van-tabs__wrap {
    height: 35px;
  }

  .van-tabs__line {
    background: linear-gradient(to right, #3699ff, #d6e9ff);
  }
</style>

<style lang="scss" scoped>
  .box {
    background: #ffff;
    border-radius: 5px;
    margin: 0.42rem 0.37rem;
    margin-top: 0;
    box-sizing: border-box;
  }

  .xbox {
    background: #ffff;
    border-radius: 5px;
    margin: 0.42rem 0.37rem;
    margin-top: 0;
    box-sizing: border-box;
    overflow-x: auto;
  }

  .el-carousel {
    z-index: 1;
  }
  .sectionBox {
    height: 100vh;
    width: 100%;
    background: #f5f5f5;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .tabTitle {
    height: 1.34rem;
    line-height: 1.34rem;
    color: #ffffff;
    background: linear-gradient(45deg, #75b9ff, #1b8bff);
    font-size: 16px;
    letter-spacing: 5px;
  }
  .mainBox {
    margin: 0.42rem 0.37rem;
    border-radius: 10px;
    overflow: hidden;
  }
  .el-carousel__container,
  .el-carousel__item,
  .el-image {
    padding: 0;
    margin: 0;
    border-radius: 10px;
    overflow: hidden;
  }
  .bottomBox {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    overflow: hidden;
  }
  .bottomBox1 {
    height: calc(100% - 7.52rem);
  }
  .bottomBox2 {
    height: calc(100% - 6.19rem);
  }
  .topDiv {
    padding: 0.4rem 10px;
    height: 0.7rem;
    background: linear-gradient(45deg, #75b9ff, #1b8bff);
    box-shadow: 0px -1px 2px 0px rgba(0, 0, 0, 0.1) inset;
  }
  .leftBox {
    float: left;
    height: 0.7rem;
    line-height: 0.7rem;
    color: #ffffff;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 150px;
  }
  .rightBox {
    float: right;
    height: 0.8rem;
  }
  .right1,
  .right2 {
    display: inline-block;
    background: linear-gradient(45deg, #ffd596, #ff8e12);
    width: 74px;
    height: 0.7rem;
    border-radius: 10px;
    overflow: hidden;
    margin-top: 0;
    padding: 0px 5px;
  }

  .right2 {
    margin-left: 5px;
  }
  .images {
    width: 20px;
    height: 20px;
    float: left;
    margin-top: 0.09rem;
  }
  .btn_text {
    float: left;
    margin-left: 4px;
    margin-top: 0.13rem;
    font-size: 0.32rem;
    color: #ffffff;
  }
  .sidebarOutBox {
    background: #75b9ff;
    height: 100%;
    display: flex;
    height: calc(100% - 1.5rem);
  }
  .sidebarOutBoxH {
    background: #75b9ff;
    height: 100%;
    display: flex;
    height: calc(100% - 0.15rem);
  }
  .van-sidebar {
    width: 112px;
    height: 100%;
    background: url("../../assets/shopping/bg.png");
    background-size: 100% auto;
    background-repeat: repeat;
    content: "";
    overflow: auto;
  }
  .van-sidebar-item {
    background: transparent;
    text-align: left;
    color: #ffffff;
    font-size: 14px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .van-sidebar-item--select {
    background: rgba(255, 255, 255, 0.4);
  }
  .van-sidebar-item--select::before {
    background-color: #1b8bff;
    position: absolute;
    top: 50%;
    left: 0;
    width: 3px;
    height: 100%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    content: "";
  }
  .inBox {
    background: #fff;
    float: right;
    width: calc(100% - 112px);
    padding: 0px 10px 0px;
    overflow-x: auto;
  }
  .searchBoxOuts {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    background: linear-gradient(to right, #75b9ff, #1b8bff);
  }
  .searchBox {
    height: 33px;
    border-radius: 5px;
    background-color: #fff;
    .inputBox {
      float: left;
      width: calc(100% - 1.9rem);
      height: 33px;
      line-height: 33px;
      border: none;
      border-radius: 15px;
      overflow: hidden;
      padding: 0px 0.133rem;
    }
  }
  .inputBox >>> .el-input__inner {
    -webkit-appearance: none;
    border: 0px !important;
    background: transparent !important;
  }
  .searchBtn {
    float: right;
    width: 1.6rem;
    // margin-left: 5px;
    height: 33px;
    line-height: 0.1rem;
    text-align: center;
    overflow: hidden;
    color: #000;
    padding: 0px;
    font-size: 12px;
  }
  .itemBox {
    width: 167px;
    margin: 15px 0px;
    height: 255px;
    padding: 0px 0px 10px;
    background-color: #fff;
    border-radius: 5px;
    border-bottom: 1px solid #f5f5f5;
    .shopImg {
      width: 167px;
      height: 185px;
      margin-right: 5px;
      border-radius: 10px;
      overflow: hidden;
      // border: 1px solid #979797;
    }
    .contBox {
      padding: 5px;
      .shopName {
        font-size: 12px;
        font-weight: bold;
        color: #4f4f4f;
        margin-bottom: 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
      }
      .shopTitle {
        color: #979797;
        font-size: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
      }
      .shopPrice {
        float: left;
        color: #1b8bff;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 45%;
      }
      .shopNum {
        float: right;
        margin-top: 3px;
        color: #979797;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 42%;
      }
    }
  }
  .more {
    clear: both;
    text-align: center;
    color: #1b8bff;
    font-size: 12px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    z-index: 12;
  }

  .block {
    width: 70%;
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    .tit1 {
      font-size: 18px;
      color: #000;
    }
    .tit2 {
      font-size: 10px;
      color: #f00;
    }
    .inputDiv {
      margin-top: 20px;
      border-radius: 10px;
      background-color: #f5f5f5;
    }
    .confirmBtn {
      margin-top: 15px;
      background-color: #1b8bff;
      width: 100%;
      height: 45px;
      color: #fff;
      border-color: #1b8bff;
      border-radius: 10px;
    }
  }
  .wrappers {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    z-index: 12;
    .blocks {
      width: calc(100% - 50px);
      background-color: #fff;
      border-radius: 10px;
      padding: 15px 10px;
      .tit1 {
        font-size: 18px;
        color: #515151;
      }
      .tit2 {
        font-size: 14px;
        color: #515151;
      }
      .inputDiv {
        margin-top: 10px;
        border-radius: 10px;
        background-color: #f5f5f5;
      }
    }
  }
</style>
